// extracted by mini-css-extract-plugin
export default {"loginForm":"login_loginForm__bVUOL","link":"login_link__Tls5-"};